export const title = "Filters";

export const clearFiltersButtonText = "Clear Filters";

export const saveFiltersButtonText = "Apply Filters";
